import { HourglassBottom } from '@mui/icons-material';
import TabTemplate from 'src/components/UI/TabTemplate';

interface TimelineHeaderProps {
  subtitle?: string;
}

export default function TimelineHeader({ subtitle }: TimelineHeaderProps) {
  return (
    <TabTemplate
      title="Linha do Tempo"
      subtitle={subtitle ?? ''}
      breadcrumbs1="Linha do Tempo"
      titleIcon={<HourglassBottom />}
      tabContent={[]}
      tabIndex={0}
      handleChange={() => {}}
    />
  );
}
